import { render } from "./CardWithTitle.vue?vue&type=template&id=842a00ba&ts=true"
import script from "./CardWithTitle.vue?vue&type=script&lang=ts"
export * from "./CardWithTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__